import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const loadedMain = () => document.querySelector('script[src*="/static/js/main."]')?.getAttribute("src");

export const VersionWatcher = () => {
  const { pathname } = useLocation();
  const stale = useRef(false);
  const first = useRef(true);
  useEffect(() => {
    const mine = loadedMain();
    if (!mine) return undefined;
    const check = () => fetch("/asset-manifest.json", { cache: "no-store" })
      .then((r) => r.json())
      .then((m) => {
        if (!m?.files?.["main.js"] || m.files["main.js"] === mine) return;
        stale.current = true;
        if (["/", "/sedzia", "/konferansjer", "/teraz-na-scenie", "/wyniki", "/lista-startowa"].includes(window.location.pathname)) window.location.reload();
      })
      .catch(() => {});
    const t = setInterval(check, 120000);
    return () => clearInterval(t);
  }, []);
  useEffect(() => {
    if (first.current) { first.current = false; return; }
    if (stale.current) { window.location.reload(); }
  }, [pathname]);
  return null;
};
